const ORG_API_URL = process.env.REACT_APP_ORG_API_URL;
const ORG_API_KEY = process.env.REACT_APP_ORG_API_KEY;
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export {ORG_API_KEY, ORG_API_URL, GOOGLE_CLIENT_ID, GOOGLE_API_KEY}